export function checkboxIsChecked(value) {
  // possible checkbox values are: 'true', 'false', null, true, or false
  return [true, 'true'].includes(value);
}
